<template>
  <div>
    <v-expansion-panels dark flat class="transparent">
      <v-expansion-panel v-for="(attachment, index) in attachments" :key="index" style="background: rgba(255, 255, 255, 0.05)" class="mb-2">
        <v-expansion-panel-header>
          <div class="d-flex align-center text-truncate">
            <v-icon left small>mdi-file-document-outline</v-icon>
            <span class="text-truncate">{{ attachment.originalName }}</span>
          </div>
          <template v-slot:actions>
            <v-btn icon small @click.stop="downloadFile(attachment)" title="Herunterladen">
              <v-icon small color="primary">mdi-download</v-icon>
            </v-btn>
            <v-icon>$expand</v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div v-if="canBePreviewed(attachment.mimeType)" class="text-center pt-2">
            <v-btn
              v-if="!previewUrls[attachment.filename]"
              small
              color="primary"
              outlined
              :loading="loadingStates[attachment.filename]"
              @click="loadPreviewUrl(attachment)">
              <v-icon left small>mdi-eye</v-icon>
              Vorschau laden
            </v-btn>

            <div v-else class="mt-3" style="height: 50vh; width: 100%; position: relative">
              <iframe
                v-if="isPdf(attachment.mimeType)"
                :src="previewUrls[attachment.filename]"
                style="width: 100%; height: 100%; border: none"></iframe>
              <img v-else :src="previewUrls[attachment.filename]" style="max-width: 100%; max-height: 100%; object-fit: contain" />
            </div>
          </div>
          <div v-else class="grey--text caption text-center pa-4">Vorschau für diesen Dateityp nicht verfügbar. Bitte lade die Datei herunter.</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import api from "@/api"

export default {
  name: "AttachmentList",
  props: {
    applicationId: {
      type: String,
      required: true,
    },
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      previewUrls: {},
      loadingStates: {},
    }
  },
  methods: {
    canBePreviewed(mimeType) {
      if (!mimeType) return false
      return mimeType === "application/pdf" || mimeType.startsWith("image/")
    },
    isPdf(mimeType) {
      return mimeType === "application/pdf"
    },
    async loadPreviewUrl(attachment) {
      this.$set(this.loadingStates, attachment.filename, true)
      try {
        const blobUrl = await api.jobApplications.previewAttachment(this.applicationId, attachment.filename)
        this.$set(this.previewUrls, attachment.filename, blobUrl)
      } catch (error) {
        console.error("Vorschau konnte nicht geladen werden", error)
        if (this.$toast) this.$toast.error("Vorschau konnte nicht geladen werden")
      } finally {
        this.$set(this.loadingStates, attachment.filename, false)
      }
    },
    async downloadFile(attachment) {
      try {
        await api.jobApplications.downloadAttachment(this.applicationId, attachment.filename, attachment.originalName)
      } catch (error) {
        console.error("Download fehlgeschlagen", error)
        if (this.$toast) this.$toast.error("Download fehlgeschlagen")
      }
    },
    cleanupUrls() {
      Object.values(this.previewUrls).forEach((url) => {
        if (url) URL.revokeObjectURL(url)
      })
      this.previewUrls = {}
    },
  },
  beforeDestroy() {
    this.cleanupUrls()
  },
}
</script>
